'use client';

import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/* --------------------------------- Base Styles --------------------------------- */

const baseButtonStyles = css`
  /* ✅ HARD LOCK text color across ALL states */
  &&,
  &&:hover,
  &&:focus,
  &&:active,
  &&:visited {
    color: #000 !important;
  }

  background: var(--c-yellow-1);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: var(--size-dual-nudge) var(--size-1h);
  border-radius: var(--radius-sm);
  gap: var(--size-half);
  cursor: pointer;
  font-weight: 700;
  line-height: 22px;
  text-decoration: none;
  border: none;

  &:hover {
    background: var(--c-yellow-2);
    transform: scale(1.05);
    box-shadow:
      rgba(0, 0, 0, 0.18) 0px 2px 4px,
      rgba(0, 0, 0, 0.13) 0px 4px 14px;
  }

  &:active {
    background: var(--c-yellow-3);
    box-shadow: none;
  }

  &:focus-visible {
    outline: 2px solid var(--c-browser-blue-1);
  }

  &:hover > span,
  &:focus > span {
    text-decoration: underline;
  }
`;

/* --------------------------------- Icons --------------------------------- */

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  font-size: var(--size-1);
  transition: transform 0.3s var(--animation-bezier);
`;

export const StyledFontAwesomeIconRotated = styled(StyledFontAwesomeIcon)`
  transform: rotate(315deg);
`;

/* --------------------------------- Button --------------------------------- */

export const StyledButtonSolid = styled.button`
  ${baseButtonStyles}
`;

/* --------------------------------- Anchor (External Links) --------------------------------- */

export const StyledAnchorSolid = styled.a`
  ${baseButtonStyles}
`;

/* --------------------------------- Link (Internal Links) --------------------------------- */

export const StyledLinkSolid = styled.a`
  ${baseButtonStyles}
`;

/* --------------------------------- Minor Variants --------------------------------- */

export const StyledButtonMinor = styled(StyledButtonSolid)``;

export const StyledLinkMinor = styled(StyledLinkSolid)``;

export const StyledAnchorMinor = styled(StyledAnchorSolid)``;
